import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { CREATE_FREE_PROMOTION_ERROR_MAP } from '../../constants';

import { StarterDashboardV2CreateFreePromotionForPetitionStarter as CreateFreePromotionForPetitionStarterQuery } from './createFreePromotion.graphql';
import type {
	StarterDashboardV2CreateFreePromotionForPetitionStarterMutation,
	StarterDashboardV2CreateFreePromotionForPetitionStarterMutationVariables,
} from './createFreePromotion.graphql';

type CreateFreePromotionReturn = { status: 'success'; id: string };
export async function createFreePromotion(
	id: string,
	{ gql: { fetch }, errorReporter }: UtilityContext,
): Promise<CreateFreePromotionReturn> {
	const { data, requestId } = await fetch<
		StarterDashboardV2CreateFreePromotionForPetitionStarterMutation,
		StarterDashboardV2CreateFreePromotionForPetitionStarterMutationVariables
	>({
		query: CreateFreePromotionForPetitionStarterQuery,
		variables: {
			input: {
				petitionId: id,
				sourceLocation: 'starter_free_promotion',
			},
		},
		rejectOnError: true,
	});

	// TODO: improve error handling in graphql responses
	if (data.createFreePromotionForPetitionStarter.__typename === 'CreateFreePromotionForPetitionStarterError') {
		const err = new Error(CREATE_FREE_PROMOTION_ERROR_MAP.NOT_ABLE.code);
		void errorReporter.report({
			error: new Error('Failed to create free promotion'),
			context: {
				requestId,
				reason: CREATE_FREE_PROMOTION_ERROR_MAP.NOT_ABLE.code,
			},
			params: {
				message: data.createFreePromotionForPetitionStarter.message,
			},
		});
		throw err;
	}

	return { status: 'success', id: data.createFreePromotionForPetitionStarter.promotion.id };
}
